import { render } from "./Sales.vue?vue&type=template&id=53f32034&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"

import "./Sales.vue?vue&type=style&index=0&id=53f32034&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-53f32034"

export default script